<div>
    <div class="card">
        <div class="card-header">
           Gestión de locaciones
        </div>
    </div>

    <div class="card">
      <div class="card-header">
        <p><strong>Ingrese los datos de la nueva locación</strong></p>
      </div>
      <div class="card-body">
        <div class="container">
            <div class="row" style="background-color: rgba#e2e2e2;">
              <p>1.Nombre</p>
                <div class="col">
                    <input type="text"  [(ngModel)]="nombre" class="form-control" placeholder="Nombre" (input)="validaboton()"   >
                </div>
            </div>
            <hr>
            <div class="row" style="background-color: rgba#9b9a9a;" >
              <p>2. Seleccione una regional / cuenca: - </p>
              <div class="form-group">
                <!-- <label for="exampleFormControlSelect1">Seleccione una regional / cuenca</label> -->
                <select class="form-control" id="exampleFormControlSelect1" [(ngModel)]="regional" (change)="validaboton()" >
                  <option>Putumayo norte</option>
                  <option>Putumayo sur</option>
                  <option>VMM</option>
                  <option>VMM-otros</option>
                  <option>Bogota</option>
                  <option>Llanos</option>
                  <option>Charapa</option>
                  <option>Chanangue</option>
                  <option>Iguana</option>
                   <option>Conejo</option>
                  <option>Perico</option>
                  <option>Espejo</option>
                </select>
              </div>
            </div>
            <hr>
            
        </div>
        <div *ngIf="alertaActiva">
            <p>
                <ngb-alert [type]="tipodeAlerta" (close)="closeAlert()">{{ mensajeAlerta }}</ngb-alert>
            </p>
        </div>
        
        <div>
          <hr>
          <button class="btn btn-success btn-block" (click)="crearLocacion()" [disabled]="botondisabled" style="float: right; margin-right: 6px;"  >¡Crear locación!</button>
        </div>
      </div>
    </div>



      <div >
        <table datatable [dtOptions]="dtOptions"[dtTrigger]="dtTrigger" class="row-border hover" id="tabla"   >
          <thead>
            <tr>
              <th>Acciones</th>
              <th>Locación</th>
              <th>Cuenca</th>

            </tr>
          </thead>
          <tbody>
             
      
            <tr *ngFor="let item of arraydeposts">
              <td><button type="button" class="btn btn-primary btn-sm" (click)="detalles(item)"> Acciones</button></td>
              <td><small>{{item.data().name}}</small></td>
              <td><small>{{item.data().regional}}</small></td>
            </tr>
            
          </tbody>
        </table>
      </div>



</div>
